import { useFormContext } from 'react-hook-form';
import { useCappsPaymentWebApiHandler_previewApplicationPayment } from '@zg-rentals/ts-capps-client-react-query';
import { getCurrencyDisplayFromDollars } from '@zg-rentals/formatters';
import { FIELD_IDS } from '../constants/wizard';
import { RENTAL_APPLICATION_PRICE, RENTAL_APPLICATION_PRICE_LONG } from '../constants/applicationsConstants';

export function useApplicationFee({ applicationId }: { applicationId?: string }) {
  const formContext = useFormContext();
  const city = formContext?.getValues(FIELD_IDS.CURRENT_RESIDENCE_CITY);
  const zip = formContext?.getValues(FIELD_IDS.CURRENT_RESIDENCE_ZIP);
  const state = formContext?.getValues(FIELD_IDS.CURRENT_RESIDENCE_STATE);

  const { data: previewPaymentData, isLoading } = useCappsPaymentWebApiHandler_previewApplicationPayment(
    {
      applicationId: applicationId ?? '',
      city,
      country: 'United States',
      postalCode: zip,
      stateOrProvince: state,
    },
    { enabled: !!(applicationId && city && zip && state) },
  );

  const hasPreviewFee = !!previewPaymentData && Number(previewPaymentData.amountWithoutTax) > 0;

  return {
    previewPaymentData,
    isLoading,
    feeDisplay: hasPreviewFee
      ? getCurrencyDisplayFromDollars({ amount: previewPaymentData.amountWithoutTax })
      : RENTAL_APPLICATION_PRICE,
    feeAmountLong: hasPreviewFee ? previewPaymentData.amountWithoutTax : RENTAL_APPLICATION_PRICE_LONG,
  };
}
